<div class="list-group-item menu-list" (click)="toggleSubMenu(item)">
    @if (item.routeLink) {
      <a [routerLink]="item.routeLink" class="btn btn-link">
        <span>{{ item.label }}</span>
      </a>
    } @else {
      <button class="btn btn-link">
        <span>{{ item.label }}</span>
      </button>
    }
</div>

@if (item.isExpanded && item.items?.length) {
  <div class="sub-menu">
    @for (child of item.items ; track $index) {
      <app-menu-item
        [navData]="child.items"
        [item]="child"
      ></app-menu-item>
    }
  </div>
}

